module.exports = __webpack_public_path__ + "img/20.e76cb7f9.svg";